const __WEBPACK_NAMESPACE_OBJECT__ = __SPARKY_LIBS__.lodash.isString;